// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"170":"b52e122f","261":"77d03875","526":"5141c7c0"}[chunkId] + ".chunk.css";
};